import styled from 'styled-components';

export const Footer = styled.footer`
  background: linear-gradient(135deg, #254d6b 0%, #1a3a52 100%);
  color: #ffffff;
  padding: 3rem 0 1.5rem;
  margin-top: auto;
  width: 100%;
  flex-shrink: 0;

  @media screen and (max-width: 768px) {
    padding: 2rem 0 1rem;
  }
`;

export const FooterContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;

  @media screen and (max-width: 768px) {
    padding: 0 1rem;
  }
`;

export const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2.5rem;
  margin-bottom: 2rem;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
    margin-bottom: 1.5rem;
  }
`;

export const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FooterTitle = styled.h3`
  font-family: 'Poppins', sans-serif;
  font-size: 1.125rem;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 1rem;
  letter-spacing: 0.025em;
`;

export const FooterLinks = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const FooterLink = styled.li`
  a {
    font-family: 'Inter', sans-serif;
    font-size: 0.9375rem;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: all 0.3s ease-in-out;
    display: inline-block;

    &:hover {
      color: #27ae60;
      transform: translateX(4px);
    }
  }
`;

export const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const ContactItem = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 0.9375rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;

  a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: color 0.3s ease-in-out;

    &:hover {
      color: #27ae60;
    }
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
`;

export const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  color: #ffffff;
  font-size: 1.125rem;
  text-decoration: none;
  transition: all 0.3s ease-in-out;
  backdrop-filter: blur(10px);

  &:hover {
    background: #27ae60;
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(39, 174, 96, 0.4);
  }

  @media screen and (max-width: 768px) {
    width: 44px;
    height: 44px;
    font-size: 1.25rem;
  }
`;

export const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 1.5rem;
  text-align: center;

  @media screen and (max-width: 768px) {
    padding-top: 1rem;
  }
`;

export const Copyright = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;

  a {
    color: #27ae60;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.3s ease-in-out;

    &:hover {
      color: #3bc775;
      text-decoration: underline;
    }
  }
`;



